import React, { Component } from "react";
import axios from "axios";
import {
  BASE_URL,
  PRODUCTS,
  COLORS,
  STYLES,
  ROOMS,
  HEADERS,
  TOKEN,
} from "../../common/api";
import Select from "react-select";

export default class SingleDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data: {},
      colors: [],
      styles: [],
      rooms: [],
      inColors: [],
      inRooms: [],
      inStyles: [],
      images: [],
      ovalImages: [],
      draggedIndex: null,
      draggedOvalIndex: null,
      status: "",
      singleImage: "",
      newSingleImage: "",
    };
  }

  getProducts = async () => {
    const { id } = this.state;
    await axios.get(BASE_URL + PRODUCTS + id).then((res) => {
      const obj = {};
      const inColors = [];
      const inStyles = [];
      const inRooms = [];
      const data = res.data;
      Object.keys(data).forEach((item) => (obj[item] = data[item]));
      data.colors.map((item) => {
        return inColors.push({ value: item.id, label: item.nameRu });
      });
      data.rooms.map((item) => {
        return inRooms.push({ value: item.id, label: item.nameRu });
      });
      data.styles.map((item) => {
        return inStyles.push({ value: item.id, label: item.nameRu });
      });
      this.setState({
        data: obj,
        status: res.status,
        inColors,
        inRooms,
        inStyles,
        singleImage: data.image,
      });
    });
  };
  

  // Обработчик начала перетаскивания
  handleDragStart = (index) => {
    this.setState({ draggedIndex: index });
  };


  // Обработчик начала перетаскивания для oval images
  handleOvalDragStart = (index) => {
    this.setState({ draggedOvalIndex: index });
  };
  
  // Обработчик перетаскивания над элементом
  handleDragOver = (e) => {
    e.preventDefault();
  };
  
  // Обработчик входа в зону drop
  handleDragEnter = (index) => {
    const { draggedIndex, images } = this.state;
    
    if (draggedIndex === null || draggedIndex === index) {
      return;
    }
    
    const newImages = [...images];
    const draggedImage = newImages[draggedIndex];
    
    // Удаляем элемент из старой позиции
    newImages.splice(draggedIndex, 1);
    // Вставляем на новую позицию
    newImages.splice(index, 0, draggedImage);
    
    this.setState({
      images: newImages,
      draggedIndex: index,
    });
  };


  // Обработчик входа в зону drop для oval images
  handleOvalDragEnter = (index) => {
    const { draggedOvalIndex, ovalImages } = this.state;

    if (draggedOvalIndex === null || draggedOvalIndex === index) {
      return;
    }

    const newOvalImages = [...ovalImages];
    const draggedImage = newOvalImages[draggedOvalIndex];

    newOvalImages.splice(draggedOvalIndex, 1);
    newOvalImages.splice(index, 0, draggedImage);

    this.setState({
      ovalImages: newOvalImages,
      draggedOvalIndex: index,
    });
  };


  // Обработчик завершения перетаскивания для oval images
  handleOvalDragEnd = async () => {
    const { ovalImages } = this.state;

    const updatedPositions = ovalImages.map((image, index) => ({
      id: image.id,
      position: index,
    }));

    try {
      const response = await fetch(BASE_URL + "oval-images/reorder/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({ images: updatedPositions }),
      });

      if (!response.ok) {
        throw new Error("Failed to update oval image positions");
      }

      console.log("Oval positions updated successfully");
    } catch (error) {
      console.error("Error updating oval positions:", error);
    }

    this.setState({ draggedOvalIndex: null });
  };

  
  // Обработчик завершения перетаскивания
  handleDragEnd = async () => {
    const { images } = this.state;
    // Обновляем позиции на бэкенде
    const updatedPositions = images.map((image, index) => ({
      id: image.id,
      position: index,
    }));
    
    try {
      const response = await fetch(BASE_URL + "images/reorder/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Добавьте ваш токен авторизации если нужно
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({ images: updatedPositions }),
      });
      
      if (!response.ok) {
        throw new Error("Failed to update positions");
      }
      
      console.log("Positions updated successfully");
    } catch (error) {
      console.error("Error updating positions:", error);
      // Можно показать уведомление об ошибке
    }

    this.setState({ draggedIndex: null });
  };

  getColors = async () => {
    await axios.get(BASE_URL + COLORS).then((res) => {
      const colors = res.data;
      const arr = [];
      colors.map((item) => arr.push({ value: item.id, label: item.nameRu }));
      this.setState({ colors: arr });
    });
  };

  getRooms = async () => {
    await axios.get(BASE_URL + ROOMS).then((res) => {
      const rooms = res.data;
      const arr = [];
      rooms.map((item) => arr.push({ value: item.id, label: item.nameRu }));
      this.setState({ rooms: arr });
    });
  };

  getStyles = async () => {
    await axios.get(BASE_URL + STYLES).then((res) => {
      const styles = res.data;
      const arr = [];
      styles.map((item) => arr.push({ value: item.id, label: item.nameRu }));
      this.setState({ styles: arr, status: res.status });
    });
  };

  getImages = () => {
    const sorted = this.state.data.photos.toSorted((a, b) => a.position - b.position);
    this.setState({ images: sorted });
  };

  getOvalImages = () => {
    const sorted = this.state.data.oval_images.toSorted((a, b) => a.order - b.order);
    this.setState({ ovalImages: sorted });

  }

  async componentDidMount() {
    await this.getProducts();
    await this.getColors();
    await this.getRooms();
    await this.getStyles();
    await this.getImages();
    this.getOvalImages();
  }

  handleChange = (event) => {
    const data = {};
    data[event.target.name] = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [event.target.name]: event.target.value,
      },
    });
  };
  handleSelect = (event, stateProp) => {
    const arr = [];
    event.map((item) => {
      arr.push({ value: item.value, label: item.label });
      return arr;
    });
    this.setState({ [stateProp]: arr });
  };
  onImageChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const singleImage = reader.result;
      const newSingleImage = file;
      this.setState({ singleImage, newSingleImage });
    };

    reader.readAsDataURL(file);
  };

  handleAddImage = async (event) => {
    
    const file = event.target.files[0];
    if (!file) return;

    // Показываем preview сразу
    const reader = new FileReader();
    reader.onload = () => {
      // Временный объект с preview
      const tempImage = {
        id: null, // временно null, пока не получим от сервера
        image: reader.result,
        position: this.state.images.length,
        isUploading: true, // флаг загрузки
      };
      this.setState({ images: [...this.state.images, tempImage] });
    };
    reader.readAsDataURL(file);

    // 1. Получите массив изображений
    const images = this.state.images;

    // 2. Определите максимальную позицию.
    let maxPosition = -1;

    if (images.length > 0) {
      // A. Используем map() для извлечения всех значений position
      const positions = images.map((item) => item.position);

      // B. Используем Math.max() с оператором spread (...)
      // для поиска наибольшего числа в массиве позиций.
      maxPosition = Math.max(...positions);
    }

    // 3. Вычислите позицию для нового изображения
    // Новая позиция всегда должна быть на 1 больше, чем максимальная существующая.
    const newPosition = maxPosition + 1;

    // Отправляем на сервер
    let formData = new FormData();
    formData.append("image", file, file.name);
    formData.append("position", newPosition);
    formData.append("product_id", this.state.id);

    try {
      const response = await axios.post(
        BASE_URL + "products/add-image/",
        formData,
        HEADERS
      );

      // Заменяем временный объект на реальный от сервера
      const images = [...this.state.images];
      const tempIndex = images.findIndex((img) => img.isUploading);
      if (tempIndex !== -1) {
        images[tempIndex] = response.data; // {id, image, position}
      }
      this.setState({ images });

      console.log("Image uploaded:", response.data);
    } catch (err) {
      console.error("Error uploading image:", err.response);
      // Удаляем временный объект при ошибке
      this.setState({
        images: this.state.images.filter((img) => !img.isUploading),
      });
      alert("Ошибка при загрузке изображения");
    }
  };

  handleUpdateImage = async (id, index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Показываем preview сразу
    const reader = new FileReader();
    reader.onload = () => {
      const images = [...this.state.images];
      // const oldImage = images[index].image; // сохраняем старое на случай ошибки
      images[index] = { ...images[index], image: reader.result };
      this.setState({ images });
    };
    reader.readAsDataURL(file);

    // Отправляем на сервер
    let formData = new FormData();
    formData.append("image", file, file.name);

    try {
      const response = await axios.patch(
        BASE_URL + `images/${id}/`,
        formData,
        HEADERS
      );

      // Обновляем данными от сервера
      const images = [...this.state.images];
      images[index] = response.data;
      this.setState({ images });

      console.log("Image updated:", response.data);
    } catch (err) {
      console.error("Error updating image:", err.response);
      // Восстанавливаем старое изображение при ошибке
      const images = [...this.state.images];
      // const oldData = this.state.images[index];
      this.setState({ images });
      alert("Ошибка при обновлении изображения");
    }
  };

  handleDeleteImage = async (index) => {
    const imageToDelete = this.state.images[index];

    // Если изображение еще загружается, просто удаляем из state
    if (imageToDelete.isUploading) {
      const images = [...this.state.images];
      images.splice(index, 1);
      this.setState({ images });
      return;
    }

    // Подтверждение удаления
    if (!window.confirm("Вы уверены, что хотите удалить это изображение?")) {
      return;
    }

    try {
      // Удаляем с сервера
      await axios.delete(BASE_URL + `images/${imageToDelete.id}/`, HEADERS);

      // Удаляем из state
      const images = [...this.state.images];
      images.splice(index, 1);
      this.setState({ images });

      console.log("Image deleted successfully");
    } catch (err) {
      console.error("Error deleting image:", err.response);
      alert("Ошибка при удалении изображения");
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { id, data, inColors, inRooms, inStyles } = this.state;
    const selectedColors = [];
    const selectedRooms = [];
    const selectedStyles = [];
    inColors.map((color) => {
      return selectedColors.push(parseInt(color.value));
    });
    inRooms.map((room) => {
      return selectedRooms.push(parseInt(room.value));
    });
    inStyles.map((style) => {
      return selectedStyles.push(parseInt(style.value));
    });

    let formData = new FormData();
    if (this.state.newSingleImage !== null && this.state.newSingleImage.name) {
      formData.append(
        "image",
        this.state.newSingleImage,
        this.state.newSingleImage.name
      );
    }
    selectedColors.forEach((color) => {
      formData.append("colors", color);
    });
    selectedRooms.forEach((room) => {
      formData.append("rooms", room);
    });
    selectedStyles.forEach((style) => {
      formData.append("styles", style);
    });
    formData.append("seoMetaUz", data.seoMetaUz);
    formData.append("seoMetaRu", data.seoMetaRu);
    formData.append("seoTitleUz", data.seoTitleUz);
    formData.append("seoTitleRu", data.seoTitleRu);
    formData.append("isTrend", data.isTrend);
    formData.append("isActive", data.isActive);
    formData.append("isNew", data.isNew);
    formData.append("price", data.price);
    formData.append("discount", data.discount);

    await axios
      .patch(BASE_URL + PRODUCTS + "post/" + id + "/", formData, HEADERS)
      .then(this.props.history.goBack())
      .catch((err) => console.log(err.response));
  };


  handleAddOvalImage = async (event) => {
    
    const file = event.target.files[0];
    if (!file) return;

    // Показываем preview сразу
    const reader = new FileReader();
    reader.onload = () => {
      const tempImage = {
        id: null,
        image: reader.result,
        position: this.state.ovalImages.length,
        isUploading: true,
      };
      this.setState({ ovalImages: [...this.state.ovalImages, tempImage] });
    };
    reader.readAsDataURL(file);

    // Определяем максимальный order
    const ovalImages = this.state.ovalImages;
    let maxPosition = -1;

    if (ovalImages.length > 0) {
      const positions = ovalImages.map((item) => item.position);
      maxPosition = Math.max(...positions);
    }

    const newPosition = maxPosition + 1;

    let formData = new FormData();
    formData.append("image", file, file.name);
    formData.append("position", newPosition);
    formData.append("product", this.state.id);

    try {
      const response = await axios.post(
        BASE_URL + "oval-img/",
        formData,
        HEADERS
      );

      const ovalImages = [...this.state.ovalImages];
      const tempIndex = ovalImages.findIndex((img) => img.isUploading);
      if (tempIndex !== -1) {
        ovalImages[tempIndex] = response.data;
      }
      this.setState({ ovalImages });

      console.log("Oval image uploaded:", response.data);
    } catch (err) {
      console.error("Error uploading oval image:", err.response);
      this.setState({
        ovalImages: this.state.ovalImages.filter((img) => !img.isUploading),
      });
      alert("Ошибка при загрузке овального изображения");
    }
  };

  handleUpdateOvalImage = async (id, index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Показываем preview сразу
    const reader = new FileReader();
    reader.onload = () => {
      const ovalImages = [...this.state.ovalImages];
      ovalImages[index] = { ...ovalImages[index], image: reader.result };
      this.setState({ ovalImages });
    };
    reader.readAsDataURL(file);

    let formData = new FormData();
    formData.append("image", file, file.name);

    try {
      const response = await axios.patch(
        BASE_URL + `oval-img/${id}/`,
        formData,
        HEADERS
      );

      const ovalImages = [...this.state.ovalImages];
      ovalImages[index] = response.data;
      this.setState({ ovalImages });

      console.log("Oval image updated:", response.data);
    } catch (err) {
      console.error("Error updating oval image:", err.response);
      alert("Ошибка при обновлении овального изображения");
    }
  };

  handleDeleteOvalImage = async (index) => {
    const imageToDelete = this.state.ovalImages[index];

    // Если еще загружается — просто убираем из state
    if (imageToDelete.isUploading) {
      const ovalImages = [...this.state.ovalImages];
      ovalImages.splice(index, 1);
      this.setState({ ovalImages });
      return;
    }

    if (!window.confirm("Вы уверены, что хотите удалить это изображение?")) {
      return;
    }

    try {
      await axios.delete(BASE_URL + `oval-img/${imageToDelete.id}/`, HEADERS);

      const ovalImages = [...this.state.ovalImages];
      ovalImages.splice(index, 1);
      this.setState({ ovalImages });

      console.log("Oval image deleted successfully");
    } catch (err) {
      console.error("Error deleting oval image:", err.response);
      alert("Ошибка при удалении овального изображения");
    }
  };


  render() {
    const {
      data,
      colors,
      inColors,
      styles,
      inStyles,
      rooms,
      inRooms,
      status,
      draggedIndex,
      draggedOvalIndex,
      images,
      ovalImages,
    } = this.state;
    
    return (
      <>
        {status === 200 && (
          <div className="tabs effect-3">
            <input type="radio" id="tab-1" name="tab-effect-3" defaultChecked />
            <span>Главная</span>
            <input type="radio" id="tab-2" name="tab-effect-3" />
            <span>Контент</span>
            <div className="line ease"></div>
            <div className="tab-content">
              <section id="tab-item-1">
                <div className="design-card">
                  <div className="design-info">
                    <div className="design-key">Наименование:</div>
                    <div className="design-value">{data.vId}</div>
                  </div>
                  <div className="design-info">
                    <div className="design-key">Коллекция:</div>
                    <div className="design-value">{data.collection_name}</div>
                  </div>
                  <div className="design-info">
                    <div className="design-key">Категория:</div>
                    <div className="design-value">{data.category_name}</div>
                  </div>
                </div>
                <div className="design-card">
                  <div className="row p-1">
                    <div className="col-12">
                      <h6>Тип</h6>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        onChange={this.handleChange}
                        value={data.isMain}
                        name="isMain"
                      >
                        <option value="true">Топ</option>
                        <option value="false">Простой</option>
                      </select>
                    </div>
                  </div>
                  <div className="row pt-4 p-1">
                    <div className="col-4 ">
                      <h6>Статус</h6>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        onChange={this.handleChange}
                        value={data.isActive}
                        name="isActive"
                      >
                        <option value="true">Актив</option>
                        <option value="false">Пассив</option>
                      </select>
                    </div>
                    <div className="col-4">
                      <h6>isNew</h6>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={data.isNew}
                        onChange={this.handleChange}
                        name="isNew"
                      >
                        <option value="true">new</option>
                        <option value="false">NOT new</option>
                      </select>
                    </div>
                    <div className="col-4">
                      <h6>isTrend</h6>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={data.isTrend}
                        onChange={this.handleChange}
                        name="isTrend"
                      >
                        <option value="true">Trend</option>
                        <option value="false">NOT Trend</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="design-card">
                  <div className="row p-1">
                    <div className="col-6">
                      <h6>Цена</h6>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        defaultValue={data.price}
                        onChange={this.handleChange}
                        name="price"
                      />
                    </div>
                    <div className="col-6">
                      <h6>Скидка</h6>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        defaultValue={data.discount}
                        onChange={this.handleChange}
                        name="discount"
                      />
                    </div>
                  </div>
                </div>

                <button
                  className="btn btn-primary"
                  onClick={(event) => this.handleSubmit(event)}
                >
                  Сохранить
                </button>
              </section>
              <section id="tab-item-2">
                <div className="filters">
                  <div className="row m-1">
                    <div className="col-12 photos-list">
                      {images.map((image, index) => (
                        <div
                          className="photos"
                          key={image.id || index}
                          draggable
                          onDragStart={() => this.handleDragStart(index)}
                          onDragOver={this.handleDragOver}
                          onDragEnter={() => this.handleDragEnter(index)}
                          onDragEnd={this.handleDragEnd}
                          style={{
                            opacity: draggedIndex === index ? 0.5 : 1,
                            cursor: "move",
                            position: "relative",
                          }}
                        >
                          <div
                            className="file-upload"
                            style={{
                              display: "flex",
                              bottom: 0,
                              top: "auto",
                              position: "absolute",
                              backgroundColor: "#28a745",
                              borderRadius: "5px",
                            }}
                          >
                            <label
                              htmlFor={`file-update_${index}`}
                              style={{
                                width: "35px",
                                height: "35px",
                              }}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </label>
                            <input
                              type="file"
                              className="form-control-file"
                              id={`file-update-rect_${index}`}
                              htmlFor={`file-update-rect_${index}`}
                              name="image"
                              onChange={(event) =>
                                this.handleUpdateImage(image.id, index, event)
                              }
                            />
                          </div>

                          <img
                            src={image.image ? image.image : image}
                            alt="images"
                            className="img-fluid pr-4"
                            style={{ width: "200px", height: "200px" }}
                          />

                          <button
                            className="btn btn-danger"
                            onClick={() => this.handleDeleteImage(index)}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </div>
                      ))}
                      <div className="file-upload">
                        <label htmlFor="file-input">
                          <i className="fa-regular fa-image fa-2xl pr-2"></i>
                          Загрузить примоугольного фото
                        </label>
                        <input
                          type="file"
                          className="form-control-file"
                          id="file-input"
                          name="image"
                          onChange={this.handleAddImage}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row m-1">
                    <div className="col-12 photos-list">
                      {ovalImages.map((image, index) => (
                        <div
                          className="photos"
                          key={image.id || index}
                          draggable
                          onDragStart={() => this.handleOvalDragStart(index)}
                          onDragOver={this.handleDragOver}
                          onDragEnter={() => this.handleOvalDragEnter(index)}
                          onDragEnd={this.handleOvalDragEnd}
                          style={{
                            opacity: draggedOvalIndex === index ? 0.5 : 1,
                            cursor: "move",
                            position: "relative",
                          }}
                        >
                          <div
                            className="file-upload"
                            style={{
                              display: "flex",
                              bottom: 0,
                              top: "auto",
                              position: "absolute",
                              backgroundColor: "#28a745",
                              borderRadius: "5px",
                            }}
                          >
                            <label
                              htmlFor={`file-update_${index}`}
                              style={{
                                width: "35px",
                                height: "35px",
                              }}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </label>
                            <input
                              type="file"
                              className="form-control-file"
                              id={`file-update-oval_${index}`}
                              htmlFor={`file-update-oval_${index}`}
                              name="image"
                              onChange={(event) =>
                                this.handleUpdateOvalImage(image.id, index, event)
                              }
                            />
                          </div>

                          <img
                            src={image.image ? image.image : image}
                            alt="images"
                            className="img-fluid pr-4"
                            style={{ width: "200px", height: "200px" }}
                          />

                          <button
                            className="btn btn-danger"
                            onClick={() => this.handleDeleteOvalImage(index)}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </div>
                      ))}
                      <div className="file-upload">
                        <label htmlFor="file-input_2">
                          <i className="fa-regular fa-image fa-2xl pr-2"></i>
                          Загрузить овалного фото
                        </label>
                        <input
                          type="file"
                          className="form-control-file"
                          id="file-input_2"
                          name="image"
                          onChange={this.handleAddOvalImage}
                        />
                      </div>
                    </div>
                  </div>



                  <div className="m-1 row pl-3 mt-3">
                    <div>
                      {this.state.singleImage && (
                        <img
                          src={
                            this.state.singleImage ? this.state.singleImage : ""
                          }
                          alt="images"
                          className="img-fluid pr-4"
                          style={{ width: "200px", height: "200px" }}
                        />
                      )}
                    </div>

                    <div className="file-upload pt-3">
                      <label htmlFor="file-input_1">
                        <i className="fa-regular fa-image fa-2xl pr-2"></i>
                        Загрузка основного фото
                      </label>
                      <input
                        type="file"
                        className="form-control-file"
                        id="file-input_1"
                        name="image"
                        onChange={this.onImageChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="filters">
                  <h6>Параметры</h6>
                  <div className="row">
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="inColors">Цвет</label>
                          <Select
                            closeMenuOnSelect={false}
                            defaultValue={inColors}
                            // components={animatedComponents}
                            placeholder="Выберите..."
                            onChange={(event) =>
                              this.handleSelect(event, "inColors")
                            }
                            name="inColors"
                            isMulti
                            options={colors}
                          />
                        </div>
                      </form>
                    </div>
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="inRooms">Комната</label>
                          <Select
                            closeMenuOnSelect={false}
                            defaultValue={inRooms}
                            // components={animatedComponents}
                            placeholder="Выберите..."
                            onChange={(event) =>
                              this.handleSelect(event, "inRooms")
                            }
                            name="inRooms"
                            isMulti
                            options={rooms}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <form>
                        <div className="form-group">
                          <label htmlFor="inStyles">Стиль</label>
                          <Select
                            closeMenuOnSelect={false}
                            defaultValue={inStyles}
                            placeholder="Выберите..."
                            onChange={(event) =>
                              this.handleSelect(event, "inStyles")
                            }
                            name="inStyles"
                            isMulti
                            options={styles}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                  <h6>SEO</h6>
                  <div className="row">
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="seoMetaUz">seoMetaUz</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={data.seoMetaUz}
                            name="seoMetaUz"
                            placeholder="Добавьте"
                            id="seoMetaUz"
                            onChange={this.handleChange}
                          />
                        </div>
                      </form>
                    </div>
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="seoMetaRu">seoMetaRu</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={data.seoMetaRu}
                            name="seoMetaRu"
                            placeholder="Добавьте"
                            id="seoMetaRu"
                            onChange={this.handleChange}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="basisUz">seoTitleUz</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={data.seoTitleUz}
                            name="seoTitleUz"
                            placeholder="Добавьте"
                            id="seoTitleUz"
                            onChange={this.handleChange}
                          />
                        </div>
                      </form>
                    </div>
                    <div className="col-6">
                      <form>
                        <div className="form-group">
                          <label htmlFor="seoTitleRu">seoTitleRu</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={data.seoTitleRu}
                            name="seoTitleRu"
                            placeholder="Добавьте"
                            id="seoTitleRu"
                            onChange={this.handleChange}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-primary"
                  onClick={(event) => this.handleSubmit(event)}
                >
                  Сохранить
                </button>
              </section>
            </div>
          </div>
        )}
      </>
    );
  }
}
